import { FileExtension } from 'types/file.types'
import { WilsonChatMessage } from './wilsonChat.types'

export const CHAT_SCROLL_DOWN_THRESHOLD = 300
export const DEFAULT_EMPTY_CHAT_MESSAGES: WilsonChatMessage[] = [
    {
        id: '1',
        content:
            'Hello! I am Wilson, your logistics coordinator. How can I help you today?',
        type: 'ai',
        payload: null,
    },
]

export const CHAT_ACCEPTED_FILE_TYPES: FileExtension[] = [
    'jpg',
    'jpeg',
    'png',
    'pdf',
    'csv',
]
export const CHAT_MAX_FILE_SIZE_MB = 5
